export default __webpack_public_path__ + "c11d173d21e910f4251c185db05891a3.ttf";